import attachment from './attachment'
import create from './create'

export default {
  ...attachment,
  ...create,
}
